
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterDcacOn as ObiConverterDcacOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-dcac-on.js';
 
 
 

 
 export const ObiConverterDcacOn = createComponent({
   react: React,
   tagName: 'obi-converter-dcac-on',
   elementClass: ObiConverterDcacOnElement,
   events: {
     
   }
  });
 
 